// admin tenant-context helpers for the ops-family pages. admins deep-link
// with ?tenant=<id> (huddle emails, support flows) while the navbar switcher
// still shows the locally selected tenant, so the page must say whose data
// it is rendering whenever the two differ.

// true when the route renders a different tenant than the navbar selection
export const tenantContextDiffers = (route, user) => {
    const routeTenant = route && route.query && route.query.tenant
    if (!routeTenant || !user || !user.tenant) return false
    return String(routeTenant) !== String(user.tenant)
}

// display name for a tenant id from the login-time tenant_options list,
// falling back to the raw id when the list does not carry it
export const tenantDisplayName = (user, tenantId) => {
    if (!tenantId) return ''
    const options = (user && user.tenant_options) || []
    const match = options.find(o => o && o.value === tenantId)
    return (match && match.text) || String(tenantId)
}

// true when the tenant has a live telematics feed: a recognized vendor
// type, or the demo fleet for demo-named tenants. mirrors the backend's
// get_telematics_client and navbar.has_telematics, but works for any
// tenant id (admins deep-link with ?tenant=). unknown tenants return
// true so the page attempts the load and falls into its normal error
// handling rather than claiming a fact we cannot check.
export const tenantHasTelematics = (user, tenantId) => {
    if (!user || !tenantId) return true
    const types = user.telematics_types || {}
    const options = user.tenant_options || []
    const known = Object.prototype.hasOwnProperty.call(types, tenantId)
        || options.some(o => o && o.value === tenantId)
    if (!known && tenantId !== user.tenant) return true
    const t = String(types[tenantId] || '').toUpperCase()
    if (['SAMSARA', 'SAUCON', 'ZONAR', 'MOTIVE', 'VERIZON_FLEETMATICS'].indexOf(t) !== -1) return true
    const ownName = (tenantId === user.tenant && user.tenant_name) ? user.tenant_name : ''
    return (tenantDisplayName(user, tenantId) + ' ' + ownName).toLowerCase().indexOf('demo') !== -1
}

// which tenant a coaching-family page should act on. staff can arrive from
// another tenant's ops desk via ?tenant= (the erm chip passes it); honor the
// route tenant only when the viewer may actually act on it — staff, a
// tenant_options member, or their own — otherwise fall back to the signed-in
// tenant so per-tenant ticket ids can never resolve against the wrong queue.
// shared by coaching_portal.vue and coaching_stats.vue so the two pages can
// never disagree about scope.
export const resolveActingTenant = (user, routeTenant) => {
    if (!user) return null
    if (!routeTenant || String(routeTenant) === String(user.tenant)) return user.tenant
    const allowed = user.role === 'admin'
        || (user.tenant_options || []).some(o => o && String(o.value) === String(routeTenant))
    return allowed ? String(routeTenant) : user.tenant
}
